// Slim crypto-js. The whole app uses ONLY AES.encrypt + enc.Utf8/Base64 (API-payload encryption in
// POST_API / auth.module + two admin views). Importing the full `crypto-js` package drags ~229KB (every
// cipher + SHA/HMAC/PBKDF2/…) into the always-loaded vendor bundle. Pulling just the needed submodules
// drops it to ~50KB while preserving the exact `CryptoJS.AES` / `CryptoJS.enc.{Utf8,Base64}` shape the
// call sites use — so this is a DROP-IN replacement (only the import path changes, no call-site edits).
import AES from 'crypto-js/aes';
import encUtf8 from 'crypto-js/enc-utf8';
import encBase64 from 'crypto-js/enc-base64';

// Symmetric key for the /v2/api POST payload wrapping (POST_API / auth.module / the two
// admin views). From the environment rather than hardcoded at each call site; it MUST match
// the server's PAYLOAD_AES_KEY (server/config.env) and web/ Nuxt's PAYLOAD_AES_KEY, since the
// same key encrypts and decrypts. The default keeps the historical value, so a build without
// the var set behaves exactly as before. Vue CLI inlines VUE_APP_* at build time — this key
// ships in the browser bundle by construction, so env buys configurability, not secrecy.
export const PAYLOAD_AES_KEY = process.env.VUE_APP_PAYLOAD_AES_KEY || "BigBoss";

export default { AES, enc: { Utf8: encUtf8, Base64: encBase64 } };
